export default __webpack_public_path__ + "static/media/nbs-gif.8d662243.gif";